@if (singleRow) {
  <tr [contract-list-element-single-row]="contract"
    [contract-list-element-single-row-toggle-show]="multiFetch"
    (contract-list-element-single-row-toggle-single-row)="setSingleRow(false)"
  ></tr>
}
@if (!singleRow) {
  <tr [contract-list-element-main]="contract"
    [contract-list-element-main-toggle-show]="multiFetch"
    (contract-list-element-main-toggle-single-row)="setSingleRow(true)"
  ></tr>
}
@for (f of fetches; track f) {
  <tr [contract-list-element-fetch]="f"></tr>
}